import { Action } from 'store/store';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { PositionEntryInput } from 'positionEntry/store/PositionEntryState';

export enum PositionEntryActionType {
    POSITION_ENTRY_INPUT_SET = 'POSITION_ENTRY_INPUT_SET',
    POSITION_ENTRY_SET = 'POSITION_ENTRY_SET',
    POSITION_ENTRY_CLEAR = 'POSITION_ENTRY_CLEAR',
}

export type PositionEntryInputSetAction = Action<
    PositionEntryActionType.POSITION_ENTRY_INPUT_SET,
    PositionEntryInput
>;

export const positionEntryInputSetAction = (
    input: PositionEntryInput
): PositionEntryInputSetAction => ({
    type: PositionEntryActionType.POSITION_ENTRY_INPUT_SET,
    payload: input,
});

export type PositionEntrySetAction = Action<
    PositionEntryActionType.POSITION_ENTRY_SET,
    PortfolioPosition
>;

export const positionEntrySetAction = (
    position: PortfolioPosition
): PositionEntrySetAction => ({
    type: PositionEntryActionType.POSITION_ENTRY_SET,
    payload: position,
});

export interface PositionEntryClearActionPayload {
    clearInput: boolean;
}

export type PositionEntryClearAction = Action<
    PositionEntryActionType.POSITION_ENTRY_CLEAR,
    PositionEntryClearActionPayload
>;

export const positionEntryClearAction = (
    clearInput?: boolean
): PositionEntryClearAction => ({
    type: PositionEntryActionType.POSITION_ENTRY_CLEAR,
    payload: { clearInput: !!clearInput },
});

export type PositionEntryAction =
    | PositionEntryInputSetAction
    | PositionEntrySetAction
    | PositionEntryClearAction;
